/* eslint-disable react-hooks/exhaustive-deps */

import { withStyles } from '@material-ui/core';

import { Box, Button,Paper, TableRow } from '@mui/material';

import { compose } from 'recompose';
import { connect } from 'react-redux';
import FullscreenSpinner from 'modules/common/fullscreenSpinner.component';
import React, { Fragment, useState } from 'react';

import {
  FilteringState,
  IntegratedFiltering,
  IntegratedPaging,
  IntegratedSorting,
  PagingState,
  SortingState
} from '@devexpress/dx-react-grid';
import { Grid, PagingPanel, Table, TableFilterRow, TableHeaderRow } from '@devexpress/dx-react-grid-material-ui';

import { getMonth } from '../../common/utils';
import { showToast } from 'modules/layout/layout.actions';
import ExpensesModal from './expensesModal.component';
import NotesModal from './notesModal.component';

const styles = theme => ({
  wideControl: {
    minWidth: 174
  },
  section: {
    marginBottom: theme.spacing(2)
  },
  selfServicePolicySelect: {
    minWidth: 300
  }
});

const VendorHistoryView = props => {
  const { vendorDetails, vendorHistory, voucherSummaries, vendorAuthNotes, expenseLines, isLoading } = props;
  const [isExpenseModalOpen, setIsExpenseModalOpen] = useState(false);
  const [isNotesModalOpen, setIsNotesModalOpen] = useState(false);
  const [selectedAuthorizationId, setSelectedAuthorizationId] = useState();

  const handleOpenModal = authId => {
    setSelectedAuthorizationId(authId);
    setIsExpenseModalOpen(true);
  };

  const handleOpenNotesModal = authId => {
    setSelectedAuthorizationId(authId);
    setIsNotesModalOpen(true);
  }

  const handleCloseNotesModal = () => {
    setIsNotesModalOpen(false);
  };

  const handleCloseModal = () => {
    setIsExpenseModalOpen(false);
  };

  const renderHeaderRow = row => {
    return (
      <TableRow sx={{ backgroundColor: '#41B7C0', '& .MuiButtonBase-root': { color: 'white !important' } }}>
        {row.children.map(c => {
          return c;
        })}
      </TableRow>
    );
  };

  const formatDate = record => {
    if(record.dateTimeStamp)
    {
      let date = new Date(record.dateTimeStamp);
      // const formatter = new Intl.DateTimeFormat('en-US', { hour: '2-digit', minute: '2-digit' });
      return (
        <Fragment key={record.dateTimeStamp}>
          <div>{`${getMonth(date.getMonth())} ${date.getDate()} ${date.getFullYear()}`}</div>
        </Fragment>
      );
    }
    else {
      return (
        <Fragment key={record.dateTimeStamp}>
          <div>&mdash;</div>
        </Fragment>
      );
    }
    
  };

const formatName = record => {
      return (
        <Fragment key={record.dateTimeStamp}>
          <div>{`${record.firstName} ${record.lastName}`}</div>
        </Fragment>
      );
  };


  const seeNotesButton = record => {
    return (
      <Box sx={{display: 'flex', flexDirection: 'row'}}>
        <Box sx={{marginRight: '10px'}}>
          <Fragment key={record.date}>
            <Button color="primary" variant="contained" sx={{ backgroundColor: '#36939b', '&:hover': { backgroundColor: '#15585e' } }} onClick={() => handleOpenNotesModal(record.fileNumber)}
            >
              See Notes
            </Button>
          </Fragment>
        </Box>
        <Box>
          <Fragment key={record.date}>
            <Button
              color="primary"
              variant="contained"
              sx={{ backgroundColor: '#36939b', '&:hover': { backgroundColor: '#15585e' } }}
              onClick={() => handleOpenModal(record.fileNumber)}
            >
              See Expenses
            </Button>
          </Fragment>
        </Box>
      </Box>
    );
  };

  const [sorting, setSorting] = useState([{ columnName: 'date', direction: 'desc' }]);

  const [columns] = useState([
    { name: 'dateTimeStamp', title: 'Date', getCellValue: formatDate },
    { name: 'clientName', title: 'Client' },
    { name: 'fileNumber', title: 'Auth Id' },
    { name: 'fullName', title: 'Full Name', getCellValue: formatName },
    { name: 'serviceType', title: 'Service Type' },
    { name: 'serviceArea', title: 'Area' },
    { name: 'notes', title: '', getCellValue: seeNotesButton },
    // { name: 'expenses', title: 'Expenses', getCellValue: seeExpensesButton }
  ]);

  const [tableColumnExtensions] = useState([
    { columnName: 'dateTimeStamp', width: 100 },
    { columnName: 'clientName', width: 200 },
    { columnName: 'fileNumber', width: 100 },
    { columnName: 'serviceType', width: 150 },
    { columnName: 'fullName', width: 175 },
    { columnName: 'serviceArea', width: 200 }
  ]);

  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [pageSizes] = useState([15, 20, 25]);
  const [filters, setFilters] = useState([]);

  const filterCell = (props) => {
    return props.column.name !== 'notes' ? <TableFilterRow.Cell {...props} /> : null;
  };

  const headerCell = (props) => {
    return props.column.name !== 'notes' ? <TableHeaderRow.Cell {...props} /> : <TableFilterRow.Cell />;
  };

  // const [logs] = useState([{date: new Date(), client: 'Demo Client', authId: '99999-119', fullName: 'Sample User', serviceType: 'Household Goods', area: 'Shipment of Goods'}]);

  return (
    <Box>
      {!isLoading && vendorDetails && vendorHistory && (
        <Box sx={{ padding: 3 }}>
          <Paper>
            <Grid rows={vendorHistory.sort((a, b) => new Date(b.date) - new Date(a.date))} columns={columns}>
              <SortingState sorting={sorting} onSortingChange={setSorting} />
              <IntegratedSorting />
              <PagingState
                currentPage={currentPage}
                onCurrentPageChange={setCurrentPage}
                pageSize={pageSize}
                onPageSizeChange={setPageSize}
              />
              <FilteringState filters={filters} onFiltersChange={setFilters} />
              <IntegratedFiltering />
              <IntegratedPaging />
              <Table columnExtensions={tableColumnExtensions} />
              <TableHeaderRow rowComponent={renderHeaderRow} cellComponent={headerCell} showSortingControls />
              <TableFilterRow cellComponent={filterCell} />
              <PagingPanel pageSizes={pageSizes} />
            </Grid>
          </Paper>
        </Box>
      )}
      {isLoading && <FullscreenSpinner />}
      <ExpensesModal
        isExpenseModalOpen={isExpenseModalOpen}
        voucherSummaries={voucherSummaries}
        expenseLines={expenseLines}
        authorizationId={selectedAuthorizationId}
        vendorId={vendorDetails?.vendorId}
        handleCloseModal={handleCloseModal}
        history={props.history}
      />
      <NotesModal
        isNotesModalOpen={isNotesModalOpen}
        authorizationId={selectedAuthorizationId}
        vendorNotes={vendorAuthNotes}
        handleCloseNotesModal={handleCloseNotesModal}
      />
    </Box>
  );
};

const mapStateToProps = state => {

};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    showToast,
  })
)(VendorHistoryView);
